/**
 * Permanent, Echoes-purchased upgrades (M5's shop UI reads/writes these via
 * SaveManager). Pure data — a balance pass means editing numbers here, not
 * hunting through the shop or Game bootstrap code.
 */
export const META_UPGRADES = {
  maxHp: {
    id: 'maxHp', name: 'Vitality', maxLevel: 10, baseCost: 50, costGrowth: 1.15, perLevel: 10,
    description: '+10 max HP per level.',
  },
  moveSpeed: {
    id: 'moveSpeed', name: 'Fleetfoot', maxLevel: 10, baseCost: 50, costGrowth: 1.15, perLevel: 0.03,
    description: '+3% move speed per level.',
  },
  dashCooldown: {
    id: 'dashCooldown', name: 'Reflex Core', maxLevel: 10, baseCost: 50, costGrowth: 1.15, perLevel: 0.1,
    description: '-0.1s dash cooldown per level.',
  },
  damage: {
    id: 'damage', name: 'Might', maxLevel: 10, baseCost: 50, costGrowth: 1.15, perLevel: 0.03,
    description: '+3% weapon damage per level.',
  },
  echoGain: {
    id: 'echoGain', name: 'Prosperity', maxLevel: 10, baseCost: 50, costGrowth: 1.15, perLevel: 0.05,
    description: '+5% Echo income per level.',
  },
  hpRegen: {
    id: 'hpRegen', name: 'Recovery', maxLevel: 10, baseCost: 50, costGrowth: 1.15, perLevel: 0.2,
    description: '+0.2 HP/sec regen per level.',
  },
  xpGain: {
    id: 'xpGain', name: 'Insight', maxLevel: 10, baseCost: 50, costGrowth: 1.15, perLevel: 0.05,
    description: '+5% XP gain per level.',
  },
  equinox: {
    id: 'equinox', name: 'Equinox', repeatable: true, baseCost: 100, costGrowth: 1.05, perLevel: 0.01,
    description: '+1% attack and maximum HP per level.',
  },
};

/** Echoes cost to buy the *next* level, given how many levels are already owned. */
export function upgradeCost(def, currentLevel) {
  return Math.round(def.baseCost * Math.pow(def.costGrowth, currentLevel));
}
